import React from 'react';

import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import ConfirmCancel from 'components/common/Dialogs/ConfirmCancel';
import dialogActions from 'modules/dialogs/actions';
import targetPowerActions from 'modules/server/targetPower/actions';
import LWTypography from 'components/common/LWTypography';
import { POWER_ACTION, POWER_STATUS } from 'utility/powerStatus';

const ServerShutdownDialogContents = ({ uniqId, onConfirm }) => {
	const dispatch = useDispatch();

	const close = () => {
		dispatch(dialogActions.close());
	};

	const submit = () => {
		close();
		dispatch(
			targetPowerActions.setServerTargetPower({
				uniqId,
				action: POWER_ACTION.SHUTDOWN,
				status: POWER_STATUS.OFF,
			}),
		);
		onConfirm();
	};

	return (
		<Form
			onSubmit={submit}
			render={({ handleSubmit }) => (
				<form onSubmit={handleSubmit}>
					<LWTypography>
						Are you sure sure you want to shutdown this server? This does not
						destroy the server and you will continued to be invoiced as normal
						while it is inactive.
					</LWTypography>
					<ConfirmCancel cancel={close} confirmType="submit" />
				</form>
			)}
		/>
	);
};

export default ServerShutdownDialogContents;
